import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";
import { normalizeQbReportsPreviewResponse } from "../../utils/qbReportsPreview";
import { normalizeExportHistoryItems } from "../../utils/exportHistoryNormalize";

/** GET /qb/reports — Export Preview (optional query: clientId, projectId, userId, teamId, startDate, endDate) */
export const fetchExportsPreview = createAsyncThunk(
  "exports/fetchPreview",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.BILLING.QB_REPORTS, params);
      return normalizeQbReportsPreviewResponse(response?.data);
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch export preview"));
    }
  }
);

/**
 * GET /billing/exports — export history
 * @param {{ type?: 'saas' | 'qb' }} [arg] — `saas` (SaaS billing page), `qb` (QuickBooks exports page); default `qb`
 */
export const fetchExportsHistory = createAsyncThunk(
  "exports/fetchHistory",
  async (arg = {}, { rejectWithValue }) => {
    const type = arg?.type === "saas" ? "saas" : "qb";
    try {
      const response = await get(API_ENDPOINTS.BILLING.EXPORTS, { type });
      const raw = response?.data;
      const list = raw?.data?.list ?? raw?.data?.data ?? raw?.list ?? [];
      const arr = Array.isArray(list) ? list : [];
      return normalizeExportHistoryItems(arr);
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch export history"));
    }
  }
);

/**
 * POST /billing/exports — create billing export
 * Body: `{ format: 'csv' | 'xlsx', reportType: 'qb' | 'saas', filters: { ... } }`
 */
export const createBillingExport = createAsyncThunk(
  "exports/createBillingExport",
  async ({ format, filters, reportType }, { rejectWithValue }) => {
    const fmt = format === "xlsx" ? "xlsx" : "csv";
    const rt = reportType === "saas" ? "saas" : "qb";
    try {
      const response = await post(API_ENDPOINTS.BILLING.EXPORTS, {
        format: fmt,
        reportType: rt,
        filters,
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Export failed"));
    }
  }
);
